import { guid } from "../util/helpers";

const fields = {
  basic: [],
  banner: {
    value:
      "https://treatec.ams3.digitaloceanspaces.com/ibis/generator/accor-allsafe-banner-de.jpg"
  }
};

function seed() {
  const basic = [
    {
      label: "Full name",
      key: "fullName",
      type: "text",
      value: "John Doe"
    },
    { label: "Job title", key: "jobTitle", type: "text", value: "Manager" },
    {
      label: "Company",
      key: "company1",
      type: "text",
      value: "ibis Styles München Ost Messe"
    },
    {
      label: "Address",
      key: "address1",
      type: "text",
      value: "Kronstadter Str. 10 • 81677 München • Deutschland"
    },
    {
      label: "Company",
      key: "company2",
      type: "text",
      value: "ibis Styles München Ost Messe"
    },
    {
      label: "Address",
      key: "address2",
      type: "text",
      value: "Kronstadter Str. 10 • 81677 München • Deutschland"
    },
    {
      label: "Email",
      key: "email",
      type: "email",
      value: "XXXXXX@accor.com"
    },
    { label: "Phone", key: "phone", type: "text", value: "" },
    { label: "Fax", key: "fax", type: "text", value: "" },
    {
      label: "Operating company name",
      key: "operatingCompanyName",
      type: "text",
      value: ""
    },
    {
      label: "Operating company infos",
      key: "operatingCompanyInfos",
      type: "text",
      value: ""
    },
    {
      label: "Operating company directors",
      key: "operatingCompanyDirectors",
      type: "text",
      value: ""
    },
    {
      label: "VAT ID number",
      key: "operatingCompanyVat",
      type: "text",
      value: ""
    }
  ];

  basic.forEach(item => {
    fields.basic.push({ ...item, id: guid() });
  });

  addPlaceholder();
}

function addPlaceholder() {
  const placeholders = [
    "John Doe",
    "Frontend developer",
    "JohnDoe LLC",
    "Avenue Road 12",
    "mail@jonhdoe.com",
    "+ 1 123 456 7890",
    "+ 1 123 456 7890",
    "META Hotels GmbH",
    "Sitz der Gesellschaft: München • Registergericht: Amtsgericht München",
    "Geschäftsführer: Thomas Ernst, Gerhard Lernberger, Peter Treiber",
    "USt-IdNr.: 203733233"
  ];

  fields.basicPlaceholder = [
    ...fields.basic.map((item, index) => {
      return { ...item, value: placeholders[index] };
    })
  ];
}

seed();

export default fields;
